export default {
  // Table column headers
  currency: "Currency",
  keyActions: "Key Actions",
  counterparty: "Counterparty",
  transactionAmount: "Transaction Amount",
  transactionTime: "Transaction Time",

  // Loading and status
  loading: "Loading...",
  noData: "No data",
  tooMuchData:
    "Too much transaction data for this address, viewing is currently not supported",

  // Message prompts
  copySuccess: "Copy successful!",
};
